import axios from '@/utils/request'
// import common from './common'
// const ERROR = "-1"
import { message } from 'ant-design-vue'
const SUCCESS = 200
const InitMethodsParam = {
  get: {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    responseType: 'json'
  },
  post: {
    headers: {
      'content-type': 'application/json'
    },
    responseType: 'json'
  },
  put: {
    headers: {
      'content-type': 'application/json'
    },
    responseType: 'json'
  },
  delete: {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    responseType: 'json'
  }
}
export default {
  /**
     * 接口配置
     *
     * @param {String} data.method  请求方式  required
     * @param {String} data.url  请求路径 required
     * @param {Object} data.params  请求入参
     * @param {Function} data.cb  成功回调 required
     * @param {Function} data.cbCodeFail  code异常回调
     * @param {Function} data.errorCb  失败回调
     * @param {Object} data.headers  header参数
     * @param {String} data.responseType  返回数据类型
     */
  api (data) {
    const {
      method = 'get',
      url,
      params = {},
      cb,
      cbCodeFail,
      errorCb,
      headers = InitMethodsParam[method].headers,
      responseType = InitMethodsParam[method].responseType
    } = data
    // axios 入参
    const initParam = {
      method,
      url,
      responseType,
      headers,
      data: params
    }
    if (method === 'get' || method === 'delete') {
      delete initParam.data
      initParam.params = params
    }
    // showLoading && common.showLoading()
    axios(initParam).then((response) => {
      // showLoading && common.hideLoading()
      if (response.code === SUCCESS) {
        cb(response.result)
      } else {
        message.warning(response.message)
        if (cbCodeFail) {
          cbCodeFail(response.result)
        }
      }
    }).catch((err) => {
      // showLoading && common.hideLoading()
      // 单独处理网络异常
      if (errorCb) {
        errorCb(err)
      }
    })
  }
}
